import { render, staticRenderFns } from "./dropdown-element.vue?vue&type=template&id=02931b48&scoped=true"
import script from "./dropdown-element.vue?vue&type=script&lang=js"
export * from "./dropdown-element.vue?vue&type=script&lang=js"
import style0 from "./dropdown-element.vue?vue&type=style&index=0&id=02931b48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02931b48",
  null
  
)

export default component.exports